const TOKEN_KEY = "token";

/** Platform owner bypass for subscription guards (matches backend seed / owner account). */
export const PLATFORM_OWNER_EMAIL = "bassamwarrior@icloud.com";

function decodeJwtSegment(segment: string): string {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const pad = base64.length % 4;
  const padded = pad ? base64 + "=".repeat(4 - pad) : base64;
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}

export function parseJwtPayload(token: string | null): Record<string, unknown> | null {
  if (!token || !token.includes(".")) {
    return null;
  }
  try {
    const parts = token.split(".");
    if (parts.length < 2) {
      return null;
    }
    const json = decodeJwtSegment(parts[1]);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getTenantTypeFromToken(token: string | null): "operator" | "diy" {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return "operator";
  }
  const v = payload["tenantType"];
  if (v === "diy" || v === "DIY") {
    return "diy";
  }
  return "operator";
}

export function isSubscriptionGuardBypass(token: string | null): boolean {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return false;
  }
  const po = payload["platformOwner"];
  if (po === true || po === "true") {
    return true;
  }
  const emailRaw = payload["email"];
  const email = typeof emailRaw === "string" ? emailRaw.trim().toLowerCase() : "";
  return email === PLATFORM_OWNER_EMAIL.toLowerCase();
}

/** True iff the JWT carries the platformOwner=true claim or the canonical platform-owner email. */
export function isPlatformOwner(token: string | null): boolean {
  return isSubscriptionGuardBypass(token);
}

export { TOKEN_KEY };
